(function(){
  // carrousels
  document.querySelectorAll('[data-car]').forEach(function(c){
    var t=c.querySelector('.mds-car__track'),d=c.querySelector('.mds-dots');if(!t)return;
    var items=t.children,n=items.length;
    if(d){for(var i=0;i<n;i++)d.appendChild(document.createElement('i'));}
    function step(){return items[0]?items[0].getBoundingClientRect().width+14:300}
    function upd(){if(!d)return;var k=Math.round(t.scrollLeft/step());[].forEach.call(d.children,function(x,j){x.classList.toggle('is-on',j==k)})}
    t.addEventListener('scroll',upd,{passive:true});upd();
    var p=c.querySelector('.mds-prev'),nx=c.querySelector('.mds-next');
    p&&p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'})});
    nx&&nx.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'})});
  });
  // onglets
  document.querySelectorAll('[data-tabs]').forEach(function(w){
    var btns=w.querySelectorAll(':scope > div > button'),pans=w.querySelectorAll(':scope > .mds-tabs__panel');
    btns.forEach(function(b,i){b.addEventListener('click',function(){
      btns.forEach(function(x){x.classList.remove('is-active')});pans.forEach(function(x){x.classList.remove('is-active')});
      b.classList.add('is-active');pans[i]&&pans[i].classList.add('is-active');
      pans[i]&&pans[i].querySelectorAll('.mds-car__track').forEach(function(t){t.scrollLeft=0});
    })});
  });
  // galerie
  var g=document.querySelector('[data-gal]');
  if(g){var th=document.querySelectorAll('.mds-gal__thumb');
    th.forEach(function(b){b.addEventListener('click',function(){g.scrollTo({left:g.clientWidth*b.dataset.i,behavior:'smooth'})})});
    g.addEventListener('scroll',function(){var k=Math.round(g.scrollLeft/g.clientWidth);th.forEach(function(x,j){x.classList.toggle('is-active',j==k)})},{passive:true});}
  // offres
  document.querySelectorAll('.mds-offer input').forEach(function(r){r.addEventListener('change',function(){
    document.querySelectorAll('.mds-offer').forEach(function(o){o.classList.toggle('is-sel',o.contains(r))})})});
  // date d'expédition (J+2 ouvrés)
  var el=document.querySelector('[data-mds-date]');
  if(el){var d=new Date(),a=0;while(a<2){d.setDate(d.getDate()+1);if(d.getDay()%6)a++}
    el.textContent=d.toLocaleDateString('it-IT',{day:'numeric',month:'long'});}
  // compteurs
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;io.unobserve(e.target);
    var n=+e.target.dataset.count,s=performance.now();(function f(t){var k=Math.min(1,(t-s)/1200);e.target.textContent=Math.round(n*k)+'%';if(k<1)requestAnimationFrame(f)})(s)})},{threshold:.4});
  document.querySelectorAll('[data-count]').forEach(function(x){io.observe(x)});
  // barre collante
  var st=document.querySelector('[data-mds-sticky]'),atc=document.getElementById('mds-atc');
  if(st&&atc){new IntersectionObserver(function(es){var r=es[0];st.classList.toggle('is-on',!r.isIntersecting&&r.boundingClientRect.top<0)}).observe(atc);}
  // boutons "remonter au formulaire"
  document.querySelectorAll('[data-mds-top]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();document.getElementById('mds-form').scrollIntoView({behavior:'smooth',block:'center'})})});
  // ajout au panier en AJAX → tiroir Moonbundle (sinon le formulaire natif envoie sur la page /cart)
  var fm=document.getElementById('mds-form');
  if(fm){fm.addEventListener('submit',function(e){
    if(!window.fetch)return;e.preventDefault();
    var bs=document.querySelectorAll('button.mds-btn');bs.forEach(function(b){b.disabled=true});
    fetch('/cart/add.js',{method:'POST',body:new FormData(fm),headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){if(!r.ok)throw r;return r.json()})
      .then(function(){setTimeout(function(){window.openMoonBundleCartDrawer?window.openMoonBundleCartDrawer():location.href='/cart'},300)})
      .catch(function(){fm.submit()})
      .finally(function(){bs.forEach(function(b){b.disabled=false})});
  });}
})();
